angular.module('pe4h').run(['$templateCache', function($templateCache) {
  $templateCache.put('components/proposals/view-small/view-small-proposal.html',
    '<div ng-controller="ViewSmallProposal">\n' +
    '    <ul class="list-group no-shadow bullets-f-style">\n' +
    '        <!-- Keep <a> tag ! -->\n' +
    '        <li class="list-group-item" data-target="#proposal" data-toggle="collapse">\n' +
    '            <a>Proposal</a>\n' +
    '            <div id="proposal" class="collapse" style="word-wrap: break-word;">\n' +
    '                <div class="rates range">\n' +
    '                    <small>Estimate:</small>\n' +
    '                    <strong ng-if="myProposal.Estimate"><font/>{{myProposal.Estimate | currency:"":2}}</strong>\n' +
    '                    <span ng-if="myProposal.Hourly==true">/hr</span>\n' +
    '                    <strong ng-if="(!myProposal.Estimate) && (!myProposal.Hourly)"><font/>{{myProposal.LowestRange | currency:"":2}} - <font/>{{myProposal.HighestRange | currency:"":2}}\n' +
    '                    </strong>\n' +
    '                </div>\n' +
    '                <span style="white-space: pre-wrap;">{{myProposal.Description}}</span>\n' +
    '                <br>\n' +
    '                <div ng-if="myProposal.Attachment != null">\n' +
    '                    <br>\n' +
    '                    <small>\n' +
    '                        <a style="font-size: 19px !important" ng-href="{{myProposal.Attachment.Url}}" target="_blank" download>\n' +
    '\n' +
    '                            {{myProposal.Attachment.Name}}</a>\n' +
    '                    </small>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </li>\n' +
    '    </ul>\n' +
    '    <hr>\n' +
    '    <messages></messages>\n' +
    '</div>\n' +
    '');
}]);
